// extracted by mini-css-extract-plugin
var _1 = "pIbI2";
export { _1 as "messageField" }
